import {CommonModule} from '@angular/common';
import {Component, computed, input, output} from '@angular/core';
import {AbstractControl, FormArray, FormControl} from '@angular/forms';
import {EmIconButtonComponent, EmIconModule} from '@em/shared/ui';
import {TranslateModule} from '@ngx-translate/core';
import {EmReadableMappingRuleComponent} from '../readable-mapping-rule/readable-mapping-rule.component';
import {MatMenuModule} from '@angular/material/menu';
import {MatIconModule} from '@angular/material/icon';

@Component({
  selector: 'em-readable-mapping-rule-list',
  templateUrl: './readable-mapping-rule-list.component.html',
  styleUrls: ['./readable-mapping-rule-list.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    MatMenuModule,
    MatIconModule,
    EmReadableMappingRuleComponent,
    EmIconButtonComponent,
    EmIconModule,
  ],
})
export class EmReadableMappingRuleListComponent {
  mappinRuleList = input.required<AbstractControl>();

  allowDelete = input<boolean>(false);
  allowReorder = input<boolean>(false);
  required = input<boolean>(false);
  edit = output<void>();
  delete = output<void>();
  moveUp = output<void>();
  moveDown = output<void>();
  moveToFirst = output<void>();
  moveToLast = output<void>();

  mappingRulesFormArray = computed(
    () => this.mappinRuleList().get('mappingRules') as FormArray,
  );

  attributeControl = computed(
    () => this.mappinRuleList().get('attribute') as FormControl,
  );
  stripHtmlControl = computed(
    () => this.mappinRuleList().get('stripHTML') as FormControl,
  );
}
